import { WhatsappLogo } from '@phosphor-icons/react';
import { CONTACT, Z_INDEX_FLOATING_WIDGET } from '@/lib/constants';

const FloatingWhatsApp = () => (
  <a
    href={CONTACT.WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="floating-whatsapp-button"
    style={{ zIndex: Z_INDEX_FLOATING_WIDGET }}
    className="fixed bottom-5 right-5 w-14 h-14 rounded-full bg-green-600 hover:bg-green-700 shadow-xl flex items-center justify-center transition-transform hover:scale-105"
  >
    <WhatsappLogo size={30} weight="fill" className="text-white" />
    <span className="sr-only">Open WhatsApp chat</span>
  </a>
);

export default FloatingWhatsApp;
